$(document).ready(() => {
  /* Login user */
  $('.log-in-form').submit(async event => {
    event.preventDefault();
    $('.submit').hide();
    $('.error-text').hide();
    $('.loader').show();
    const form = $('.log-in-form');
    const email = $(form).find('#email').val();
    const password = $(form).find('#password').val();
    const data = {action: 'mpc_member_login', email, password};
    const result = await $.post(ajax.ajax_url, data);
    console.log(result);
    if (result.success) {
      window.location = result.url;
    } else {
      $('.error-text').show();
    }
    $('.loader').fadeOut();
    $('.submit').show();
  });

  /* Log out member */
  $('#logout').click(async event => {
    const result = await $.post(ajax.ajax_url, { action: 'mpc_member_logout' });
    window.location = result.url;
  });

  /* Register member */
  $('.delete-member').click(async event => {
    event.preventDefault();
    const id = $(event.target).attr('data-user');
    const result = await $.post(ajax.ajax_url, { action: 'mpc_delete_member', member: id });
    window.location.reload();
  });

  /* Register member */
  $('.member-status').click(async event => {
    event.preventDefault();
    const id = $(event.target).attr('data-user');
    $(event.target).removeClass('status-member');
    $(event.target).removeClass('status-platinum');
    const result = await $.post(ajax.ajax_url, { action: 'mpc_set_status', member: id });
    $(event.target).addClass('status-' + result.status.toLowerCase() );
    $(event.target).text(result.status);
  });
  
  $('.mypages-form').submit(async event => {
    event.preventDefault();
    const data = $('.mypages-form').serialize();
    const result = await $.post(ajax.ajax_url, { action: 'mpc_save_member_data', data: data });
    $('.mypages-form').find('button').text('Sparat!');
    // window.location.reload();
    console.log(result);
  });

  $('#offer-mail-form').submit(async event => {
    event.preventDefault();
    $('#offer-mail-form').find('.btn').hide();
    $('#offer-mail-form').find('.loader').css('display', 'inline-block');
    const data = $('#offer-mail-form').serialize();
    $('#offer-mail-form').find('#message').hide();
    const result = await $.post(ajax.ajax_url, { action: 'mpc_submit_offer_form', data: data });
    $('.offer-form-result').show();
    $('.offer-form').hide();
    console.log(result);
    $('#offer-mail-form').find('.loader').css('display', 'none');
  });


  /* My pages member */
  $('.register-member-form').submit(async event => {
    event.preventDefault();
    $('.submit').hide();
    $('.loader').css('display', 'inline-block');
    $('.error-text, .error-message, .error-message, #password-invalid, #password-not-match').hide();
    const form = $('.register-member-form');
    const membernr = $(form).find('#membernr').val();
    const email = $(form).find('#email').val();
    const password = $(form).find('#password').val();
    const terms = $(form).find('#terms').val();
    const data = {  action: 'mpc_member_register', membernr, email, password, terms};
    const result = await $.post(ajax.ajax_url, data);
    console.log(result);
    $('.loader').hide();
    if (result.success) {
      window.location = result.url;
    } else {
      $('.error-message').text(result.message);
      $('.error-message').show();
    }
    $('.submit').show();
  });

  function testPassword(string) {
    return  string && string.length > 2;
    // return  string && string.length > 7 && /^(?=.*[a-zA-Z])(?=.*[0-9])/.test(string)
  }

  function validateRegisterForm(){
    const form = $('.register-member-form');
    const membernr = $(form).find('#membernr').val();
    const email = $(form).find('#email').val();
    const password = $(form).find('#password').val();
    // const passwordRepeat = $(form).find('#passwordRepeat').val();
    const terms = $(form).find('#terms') .val() == 'agree'? 1 : 0;
    $(form).find('button').prop('disabled', !(email && testPassword(password) && terms));
  }

  $('.register-member-form').keyup(validateRegisterForm);
  $('.register-member-form').click(validateRegisterForm);
  $('.register-member-form').change(validateRegisterForm);

  $('#password').keyup(() => {
    $('#password-invalid').hide();
    const p = $('form').find('#password').val();
    if (p && !testPassword(p)){
      $('#password-invalid').show();
      return;
    }
  });

  $('#password, #passwordRepeat').keyup(() => {
    if(!$('#passwordRepeat').length) return;

    $('#password-not-match').hide();
    const p = $('form').find('#password').val();
    const p2 = $('form').find('#passwordRepeat').val();
    if (p.length > 0 && p2.length > 0 && p !== p2){
      $('#password-not-match').show();
      return;
    }
  });

  /* Agree with terms */
  $("#terms").click(() =>{$("#terms").val( $("#terms").val() == 'agree' ? '' : 'agree')});

  /* request password reset */
  $(".forgot-password-form").submit(async() => {
    $('.submit').hide();
    $('.loader').css('display', 'inline-block');
    $("#request-rejected, #request-sent").hide();
    const email = $(".forgot-password-form").find('#email').val();
    const result = await $.post(ajax.ajax_url, {action: 'mpc_member_request_password_reset', email});
    console.log(result);
    if(result.rejected){
      $("#request-rejected").show();
    }
    if(result.sent){
      $("#request-sent").show();
      setTimeout(() => window.location = result.url, 2000);
    }
    $('.loader').hide();
    $('.submit').show();
  });
  
  $(".forgot-password-form").find('#email').keyup(() => {
    $(".forgot-password-form").find('button').prop('disabled', !$(".forgot-password-form").find('#email').val());
  });



  function validatePasswordReset() {
    const password = $(".reset-password-form").find('#password').val();
    const passwordRepeat = $(".reset-password-form").find('#passwordRepeat').val();
    const token = $(".reset-password-form").find('#token').val();
    $('.reset-password-form').find('button').prop('disabled', !(password == passwordRepeat && testPassword(password) && token));
  }
  
  /* reset password  */
  $('.reset-password-form').change(validatePasswordReset);
  $('.reset-password-form').keyup(validatePasswordReset);
  $(".reset-password-form").submit(async() => {
    $('.loader').css('display', 'inline-block');
    $('.submit').hide();
    $("#reset-error").hide();
    const password = $(".reset-password-form").find('#password').val();
    const token = $(".reset-password-form").find('#token').val();
    const result = await $.post(ajax.ajax_url, {action: 'mpc_member_submit_password_reset', password, token});
    console.log(result);
    if(result.rejected){
      $("#reset-error").show();
    }
    if(result.success){
      window.location = result.url;
    }
    $('.loader').hide();
    $('.submit').show();
  });

  if( $('.mpc-card').length ) {
    setTimeout(() => $('.mpc-card-back').fadeOut(), 2500);
    setTimeout(() => {
      $('.mpc-card-front').fadeIn();
      $('.mpc-card').addClass('clickable');
    }, 3400);
   
    $('.mpc-card').click( () => {
      const animating = $('.mpc-card').hasClass('animating');
      const clickable = $('.mpc-card').hasClass('clickable');
      if( animating || !clickable ) return;
      $('.mpc-card').addClass('animating')
      $('.mpc-card-front').fadeOut();
      setTimeout(() => $('.mpc-card-back').fadeIn(), 400);
      setTimeout(() => $('.mpc-card-back').fadeOut(), 1200);
      setTimeout(() => {
        $('.mpc-card-front').fadeIn();
        $('.mpc-card').removeClass('animating')
      }, 1600);
    });
    
  }


});
